import { createAction, createReducer } from '@reduxjs/toolkit';

const NEW_BATCH = createAction('endpoints/newBatch');
const SET_LIST = createAction('endpoints/setList');
const START_LOADING = createAction('endpoints/startLoading');
const FINISHED_LOADING = createAction('endpoints/finishLoading');
const LOAD_FAILED = createAction('endpoints/loadFailed');

export const actions = {
  NEW_BATCH,
  SET_LIST,
  START_LOADING,
  FINISHED_LOADING,
  LOAD_FAILED,
};

function finishLoading(prev) {
  return { ...prev, loading: false };
}

function startLoading(prev) {
  return { ...prev, loading: true };
}

// A failed list request used to leave `loading` stuck at true with no trace of
// why (e.g. a 401 when the CMS session is missing), so the UI and Copilot could
// not tell "still loading" from "failed". Errors are kept per runtime version.
function loadFailed(prev, action) {
  const { version, message } = action.payload;
  return { ...prev, loading: false, errors: { ...prev.errors, [version]: message } };
}

function newBatch(prev, action) {
  const { payload } = action;
  const { list, version } = payload;
  const newVersionList = [...prev.list[version], ...list];

  return {
    ...prev,
    touched: true,
    errors: { ...prev.errors, [version]: null },
    list: { ...prev.list, [version]: newVersionList },
  };
}

function setList(prev, action) {
  const { payload } = action;
  const { list, version } = payload;

  return {
    ...prev,
    touched: true,
    errors: { ...prev.errors, [version]: null },
    list: { ...prev.list, [version]: list },
  };
}

const reducer = createReducer(
  {
    loading: false,
    touched: false,
    errors: {
      v1: null,
      v2: null,
    },
    list: {
      v1: [],
      v2: [],
    },
  },
  {
    [SET_LIST]: setList,
    [NEW_BATCH]: newBatch,
    [FINISHED_LOADING]: finishLoading,
    [START_LOADING]: startLoading,
    [LOAD_FAILED]: loadFailed,
  }
);

export default reducer;
